module.exports = __webpack_public_path__ + "media/images/facebook_badge-798919d1.png";